<template>
  <div class="column-filter"
    v-show="filter">
    <div>
      <span>
        <localized-label>columnViewLabel</localized-label>
      </span>
      <button @click="resetFilter">
        <localized-label>columnResetLabel</localized-label>
      </button>
      <div v-if="message" class="no-columns">
        <span>{{messageTitle}}</span>
      </div>
    </div>
    <div class="columns">
      <div v-for="(item, index) in items"
        :key="index">
        <div class="filter-checkbox">
          <input type="checkbox"
            :id="`${index}${id}`"
            :value="selectedFilters[index]"
            v-model="selectedFilters[index]"
            :disabled="columnSize > columnMaxSize && !selectedFilters[index]"
            @input="selectFilters">
          <label :for="`${index}${id}`">
            <span>
              {{getHeaderTranslation(item.value)}}
            </span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { upperFirst } from 'lodash';

export default {
  name: 'ColumnSelectFilter',
  props: {
    columnSize: {
      type: Number,
    },
    columnMaxSize: {
      type: Number,
    },
    filter: {
      type: Boolean,
    },
    id: {
      type: String,
    },
    items: {
      type: Array,
    },
    message: {
      type: Boolean,
    },
    messageTitle: {
      type: String,
    },
    selected: {
      type: Array,
    },
    title: {
      type: String,
    },
  },
  data() {
    return {
      selectedFilters: [],
    };
  },
  computed: {
    ...mapGetters([
      'translation',
    ]),
  },
  watch: {
    selected() {
      this.selectedFilters = this.selected;
    },
  },
  methods: {
    getHeaderTranslation(value) {
      const key = `tableHeader${upperFirst(value)}Label`;
      return this.translation(key);
    },
    resetFilter() {
      this.$emit('resetInputFilter');
    },
    selectFilters() {
      this.$emit('inputFilter', this.selectedFilters);
    },
  },
};
</script>
<style lang="scss">
@import "../style/mixins/scrollbar";
.column-filter {
  width: 200px;
  border-radius: 2px;
  border: solid 1px #b0b8c1;
  background-color: $tableWhite;
  position: absolute;
  text-align: center;
  padding: 10px;
  div {
    &:first-child {
      > span {
        font-size: 16px;
        line-height: normal;
        letter-spacing: normal;
        color: #6b7585;
        padding-top: 16px;
      }
      button {
        width: 100%;
        height: 30px;
        border-radius: 1px;
        background-color: #929cac;
        font-size: 14px;
        color: $tableWhite;
        margin-top: 16px;
      }
    }
  }
  .no-columns {
    color: #e37d7d;
    font-size: 11px;
    margin-top: 10px;
  }
  .columns {
    max-height: 35em;
    margin-top: 20px;
    overflow: auto;
      &:hover {
        @include scrollbar(6px, 3px, #b0b8c1, #e8ecee, (1px solid #b0b8c1));
    }
    .filter-checkbox {
      input {
        &:checked {
          + label:after {
            left: 5px;
          }
        }
      }
      label {
        display: flex;
        align-items: flex-start;
        color: #6b7585;
        font-weight: 500;
        text-align: left;
        > span {
          margin-top: 5px;
        }
      }
    }
  }
}
</style>
